import { useInitActionCombo } from '../../../commons/combobox/initActionCombo.js';

import { useRemoteCombobox } from '@/setup/remoteCombobox.js';
import { reactive, getCurrentInstance, ref, computed } from 'vue';

export const useCAPaymentDataCommon = () => {
  const { proxy } = getCurrentInstance();
  const { comboboxLoadData, submitQuickAdd } = useRemoteCombobox();

  // Tạo object lưu dữ liệu các field
  const comboboxDataRemote = reactive({
    budget_source_name: [],
    budget_chapter_code: [],
    budget_sub_kind_item_code: [],
    budget_item_code: [],
    project_code: [],
    bank_account: [],
    activity_name: [],
    statistic_code: [],
    debit_account: [],
    credit_account: [],
    accounting_object_code: [],
    purchase_purpose_id: [],
    budget_fees_id: [],
    budget_fees_code: [],
  });

  // toggle detail
  const toggleAbove = ref(true);
  const toggleAboveHandler = () => {
    toggleAbove.value = !toggleAbove.value;
  };

  // Active tab hạch toán hay thống kê
  const selectedTab = ref(1);
  const currentLayout = ref('CAPaymentDepositDetailDetail')
  const selectedTabHandler = value => {
    selectedTab.value = value;
  };

  //#region khởi tạo config cho combox trong grid
  const {
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetSubKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    accountComboMostDetailConfig,
    projectComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    purchasePurposeComboConfig,
    budgetFeesComboConfig,
    budgetProvideComboConfig,
    budgetDetailItemComboConfig,
    typeOfFundComboConfig,
    fundStructureComboConfig,
    TaskComboConfig,
    contractComboConfig,
    topicComboConfig,
    budgetKindItemComboConfig,
    accountComboParalellConfig,
  } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);
  //#endregion

  return {
    comboboxDataRemote,

    toggleAbove,
    toggleAboveHandler,
    selectedTab,
    currentLayout,
    selectedTabHandler,
    // config các field của grid ở dạng combo
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetSubKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    accountComboMostDetailConfig,
    projectComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    purchasePurposeComboConfig,
    budgetFeesComboConfig,
    budgetProvideComboConfig,
    budgetDetailItemComboConfig,
    typeOfFundComboConfig,
    fundStructureComboConfig,
    TaskComboConfig,
    contractComboConfig,
    topicComboConfig,
    TaskComboConfig,
    budgetKindItemComboConfig,
    budgetDetailItemComboConfig,
    fundStructureComboConfig,
    topicComboConfig,
    contractComboConfig,
    // func combo
    submitQuickAdd,
    comboboxLoadData,
    budgetKindItemComboConfig,
    accountComboParalellConfig,
  };
};
